import { HIDE_LOADING, SHOW_LOADING } from "./actionType";

const initialState = {
  show: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HIDE_LOADING:
      return { ...state, show: false };
    case SHOW_LOADING:
      return { ...state, show: true };

    default:
      return state;
  }
};
